import { render, staticRenderFns } from "./PrimaryActionButton.vue?vue&type=template&id=e5786148&scoped=true&"
import script from "./PrimaryActionButton.vue?vue&type=script&lang=js&"
export * from "./PrimaryActionButton.vue?vue&type=script&lang=js&"
import style0 from "./PrimaryActionButton.vue?vue&type=style&index=0&id=e5786148&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5786148",
  null
  
)

export default component.exports